import { useEffect, useState } from 'react';
import { A25, A25Input, A25Output } from 'api/U002';
import { FetchError } from 'api/API';

export function useValidateMailSession(
  input: A25Input
): [A25Output | undefined, boolean, Error | null, () => void] {
  const [loading, setLoading] = useState<boolean>(true);
  const [result, setResult] = useState<A25Output>();
  const [err, setError] = useState<Error | null>(null);

  const [refreshCount, setRefreshCount] = useState<number>(0);
  const refresh = () => setRefreshCount(refreshCount + 1);

  const validateMailSession = async (input: A25Input, cancellation: AbortSignal) => {
    return await A25(input, cancellation);
  };

  useEffect(() => {
    if (!input.sessionId) {
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    const cancellation = controller.signal;

    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const result = await validateMailSession(input, cancellation);
        setResult(result);
      } catch (err) {
        console.error(err);
        setResult(undefined);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          setError(flooredError);
          console.log({ flooredError });
          return flooredError;
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort();
    };
  }, [input.sessionId, refreshCount]);

  return [result, loading, err, refresh];
}
